module.exports = __webpack_public_path__ + "img/b6.de9d7836.png";